/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import Tabs from './site/tabs';
import Features from './site/features';
import Counter from './site/counter';
import Timeline from './site/timeline';
import Drops from './site/drops';
import AOS from 'aos';
import HardwareAjax from './site/hardwareAjax';
import LoadMoreHardware from './site/loadMoreHardware';
import Preloader from './site/preloader';
import Reseller from './site/reseller';
import StoreMap from './site/storeMap';
import FindStore from './site/findStore';
import Option from './site/option';
import HolidaysForm from './site/holidaysForm';
import EloaForm from './site/eloaForm';
import EloaSendMail from './site/eloaSendMail';
import EloaDownloadPDF from './site/eloaDownloadPDF';
import SearchRates from './site/searchRates';

//Do not comment the signature import! We need it for the signature to work.
//DO NOT REMOVE
import {Signature} from './site/signature';

/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	Reseller.init();
	Tabs.init();
	Features.init();
	Counter.init();
	Timeline.init();
	Drops.init();
	HardwareAjax.init();
	LoadMoreHardware.init();
	Preloader.init();
	AOS.init({
		once: true,
		duration: 600,
		disable: function() {
			const maxWidth = 1200;
			return window.innerWidth < maxWidth;
		}
	});
	StoreMap.init();
	FindStore.init();
	Option.init();
	HolidaysForm.init();
	EloaForm.init();
	EloaSendMail.init();
	EloaDownloadPDF.init();
	/* Signature.init(); */
	SearchRates.init();
});
